import { preloadSolutionDemoRuntime } from "./solution-demo-runtime-preload";

let earlyPreloadStarted = false;

/** Idempotent: warms solution demo JS + images before the section mounts. */
export function triggerSolutionDemoEarlyPreload(): void {
	if (earlyPreloadStarted || typeof window === "undefined") {
		return;
	}
	earlyPreloadStarted = true;
	void preloadSolutionDemoRuntime();
}

export function solutionDemoEarlyPreloadIntentHandlers(): {
	onPointerEnter: () => void;
	onFocus: () => void;
} {
	return {
		onPointerEnter: triggerSolutionDemoEarlyPreload,
		onFocus: triggerSolutionDemoEarlyPreload,
	};
}

export function isSolutionDemoHashHref(href: string): boolean {
	return href.includes("#solution");
}

/** Test-only: reset the idempotent guard between cases. */
export function resetSolutionDemoEarlyPreloadForTests(): void {
	earlyPreloadStarted = false;
}

export function hasSolutionDemoEarlyPreloadStartedForTests(): boolean {
	return earlyPreloadStarted;
}
